'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const clsx = require('clsx');
const components_navigation_IconButton_IconButton = require('../../navigation/IconButton/IconButton.cjs.js');
const components_display_Modal_useUnscrollableBody = require('./useUnscrollableBody.cjs.js');
const components_display_Modal_useFocusTrap = require('./useFocusTrap.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_17zwg_17";
const rootIn = "_root-in_17zwg_27";
const fadeIn = "_fade-in_17zwg_1";
const rootOut = "_root-out_17zwg_37";
const fadeOut = "_fade-out_17zwg_1";
const overlay = "_overlay_17zwg_47";
const modal = "_modal_17zwg_56";
const styles = {
	root: root,
	rootIn: rootIn,
	fadeIn: fadeIn,
	rootOut: rootOut,
	fadeOut: fadeOut,
	overlay: overlay,
	modal: modal
};

const Modal = ({ "aria-label": ariaLabel = void 0, canClose = true, canScrollBody, children, onClosed }) => {
  const [isOpen, setIsOpen] = React.useState(true);
  const modalRef = React.useRef(null);
  components_display_Modal_useUnscrollableBody.useUnscrollableBody({ shouldAllowScroll: canScrollBody === true });
  const onClose = () => {
    if (canClose) {
      setIsOpen(false);
    }
  };
  const onAnimationEnd = () => {
    if (isOpen === false) {
      onClosed();
    }
  };
  React.useEffect(() => {
    const onEscape = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keyup", onEscape, { capture: true });
    return () => {
      window.removeEventListener("keyup", onEscape, { capture: true });
    };
  });
  components_display_Modal_useFocusTrap.useFocusTrap(modalRef);
  const overlay = (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    React__default.default.createElement("div", { className: styles.overlay, "data-testid": "ModalOverlay", onClick: onClose })
  );
  const closeButton = !!canClose && React__default.default.createElement(components_navigation_IconButton_IconButton.IconButton, { "aria-label": "Close modal", color: "icon-ghost", icon: "formX", onClick: onClose, size: "medium" });
  const onlyChild = children && React.Children.only(children);
  const modalChildren = Object.assign(Object.assign({}, onlyChild), { props: Object.assign(Object.assign({}, children.props || {}), { closeButton }) });
  const modal = React__default.default.createElement("div", { "aria-label": ariaLabel, "aria-live": "polite", "aria-modal": "true", className: styles.modal, ref: modalRef, role: "dialog", "data-zds": true }, modalChildren);
  return React__default.default.createElement(
    "div",
    { className: clsx.clsx(styles.root, isOpen ? styles.rootIn : styles.rootOut), "data-testid": "Modal", onAnimationEnd, "data-zds": true },
    overlay,
    modal
  );
};

exports.Modal = Modal;
//# sourceMappingURL=Modal.cjs.js.map
